import React from 'react';
import { useLocation, Link } from 'react-router-dom';

function Results() {
  const location = useLocation();
  const { state } = location;
  const score = state?.score || 0;
  const total = state?.total || 0;
  const percentage = Math.round((score / total) * 100);

  const isGameOver = state?.isGameOver || false;

  const getResultMessage = () => {
    if (isGameOver) return 'GAME OVER';
    if (percentage >= 90) return 'OUTSTANDING!';
    if (percentage >= 70) return 'GREAT JOB!';
    if (percentage >= 50) return 'GOOD EFFORT!';
    return 'KEEP PRACTICING!';
  };

  return (
    <div className="w-full">
      <div className="max-w-md mx-auto mt-8">
        <div className={`border-4 border-black p-8 text-center shadow-[12px_12px_0_0_#000] ${isGameOver ? 'bg-red-500 text-white' : 'bg-acid text-black'}`}>
          <h1 className={`text-2xl md:text-3xl font-bold mb-8 uppercase tracking-widest border-b-4 border-dashed pb-4 ${isGameOver ? 'border-white text-white' : 'border-black text-black'}`}>
            {isGameOver ? 'GAME OVER' : 'STAGE CLEAR'}
          </h1>

          <div className="relative w-48 h-48 mx-auto mb-12">
            <svg className="w-full h-full" viewBox="0 0 36 36">
              <path
                d="M18 2.0845
                  a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
                fill="none"
                stroke={isGameOver ? '#fff' : '#000'}
                strokeWidth="1"
                strokeDasharray="1,1"
              />
              <path
                d="M18 2.0845
                  a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
                fill="none"
                stroke={isGameOver ? '#fff' : '#000'}
                strokeWidth="3"
                strokeDasharray={`${percentage}, 100`}
                className="transition-all duration-1000"
              />
            </svg>
            <div className="absolute inset-0 flex items-center justify-center">
              <span className={`text-2xl md:text-3xl font-bold px-2 border-2 ${isGameOver ? 'bg-red-500 text-white border-white' : 'bg-acid text-black border-black'}`}>
                {percentage}%
              </span>
            </div>
          </div>

          <p className={`text-sm md:text-base mb-6 uppercase tracking-widest leading-loose ${isGameOver ? 'text-white' : 'text-black'}`}>
            FINAL SCORE: <br/>
            <span className={`text-2xl font-bold border-b-4 inline-block mt-2 pb-1 ${isGameOver ? 'text-white border-white' : 'text-black border-black'}`}>{score * 100}</span> 
            <br/>
            <span className={`text-xs mt-2 inline-block ${isGameOver ? 'text-white' : 'text-black'}`}>({score} / {total} HITS)</span>
          </p>

          <p className={`text-sm md:text-lg font-bold mb-12 uppercase border-t-4 border-dashed pt-4 ${isGameOver ? 'text-white border-white' : 'text-black border-black'}`}>
            {getResultMessage()}
          </p>

          <Link
            to="/"
            className={`inline-block border-4 px-8 py-4 text-xs md:text-sm font-bold transition-none uppercase tracking-widest shadow-[6px_6px_0_0_#000] hover:translate-y-1 hover:translate-x-1 hover:shadow-[2px_2px_0_0_#000] active:translate-y-1 active:translate-x-1 active:shadow-[2px_2px_0_0_#000] ${isGameOver ? 'border-white bg-red-600 text-white hover:bg-white hover:text-red-600 active:bg-white active:text-red-600' : 'border-black bg-acid text-black hover:bg-black hover:text-acid active:bg-black active:text-acid'}`}
          >
            INSERT COIN
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Results;
